<script>

  import { onMount } from "svelte";
</script>

<style>
  .timesheet-pto-request {
    font-size: 1em;
    font-weight: bolder;
    margin: 0 auto;
    margin-top: 10rem;
    text-align: center;
    }
</style>

<div class="timesheet-pto-request">
  <span class="fa fa-warning fa-10x"></span>
  <br>
  Page Not Found
</div>
